export class DocumentTaskUpdate {

  taskId: number;
  documentIds: number[] = [];
  transportId: number;
}
